// useCheckLogin.js
import { useDrawerOpenFun } from "../Context/modelContext";

export const useCheckLogin = () => {
  const { setLoginModal } = useDrawerOpenFun();

  // Custom Hook to check login status
  const checkLogin = (action) => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      setLoginModal(true);
      return false;
    }

    action();
    return true;
  };

  return checkLogin;
};
